// extracted by mini-css-extract-plugin
module.exports = {"manage-variant-container":"_2sXZ4TQUKOXcRhM45T0i44","apply-item-pricing":"_29OpOwyATYu3Aytz9h-ceZ","apply-item-pricing-border":"_27YCVVZNBlzRDbtjocICs6"};